import { __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import styles from './Info.module.esm.js';

var TooltipTrigger = function (_a) {
    var className = _a.className, getTriggerProps = _a.getTriggerProps, triggerRef = _a.triggerRef;
    return (React.createElement("i", __assign({ "data-testid": "info-tooltip-trigger" }, getTriggerProps({
        className: classNames('icon-information', styles.root, className),
        ref: triggerRef,
    }))));
};

export { TooltipTrigger as default };
//# sourceMappingURL=TooltipTrigger.esm.js.map
